import {
    addBlockReferenceBefore,
    addBlockReferenceBeforeWrapper
} from 'Component/LayoutUpdate';
import { registerLayoutPlugin } from 'LayoutPlugins/registry/layoutPluginRegistry';
import {
    BR_PRODUCT_CART_POP_UP_RECOMMENDED,
    BR_PRODUCT_CART_POP_UP_TOP
} from 'Util/blocks';

registerLayoutPlugin('AddToCartPopUp', {
    renderProduct: (render) => addBlockReferenceBeforeWrapper(BR_PRODUCT_CART_POP_UP_TOP)([], render),

    renderProductLinksBefore: (render) => addBlockReferenceBefore(BR_PRODUCT_CART_POP_UP_RECOMMENDED)([], render)
});
